import React from 'react';

import './sparkles.css';

type SparklesProps = {
  // Scopes the layout: each screen positions `.spark.sN` / `.flake.fN`
  // under its own class (see landing.css, room.css).
  className: string;
};

/*
 * Decorative four-point sparkles and six-point ice flakes that twinkle and
 * drift behind a screen. Purely visual; hidden from assistive tech.
 */
export const Sparkles = ({ className }: SparklesProps) => (
  <div className={`sparkles ${className}`} aria-hidden="true">
    <span className="spark s1" />
    <span className="spark s2" />
    <span className="spark s3" />
    <span className="spark s4" />
    <span className="spark s5" />
    <span className="spark s6" />
    <span className="flake f1" />
    <span className="flake f2" />
    <span className="flake f3" />
    <span className="flake f4" />
  </div>
);
